<template>
  <div v-if="selectedItems.length">
    <h3>{{ $t('complaintForm.selected_components') }}</h3>
    <div :class="$style['table-headline']">
      <span :class="$style.bold">{{ $t('complaintForm.claim.error_desc_table_component') }}</span>
      <span></span>
      <span :class="$style.bold">{{
        $t('complaintForm.claim.error_desc_table_max_quantity')
      }}</span>
    </div>
    <div v-for="(item, index) in selectedItems" :key="index" :class="$style.item">
      <span>{{ item.name }}</span>
      <span> | </span>
      <span v-if="item.quantity" :class="[$style.bold, $style['align-right']]"
        >{{ item.quantity }}x</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComplaintFormComponentErrorDesc',
  props: {
    selectedItems: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" module>
.bold {
  font-weight: var(--font-weight-bold);
}

.align-right {
  text-align: right;
}

.table-headline {
  position: relative;

  display: grid;
  grid-template-columns: 18fr 1fr 5fr;

  align-items: center;
  margin-bottom: 0.4rem;

  border-bottom: 1px solid var(--primary);
}

.item {
  position: relative;

  display: grid;
  grid-template-columns: 18fr 1fr 3fr;

  margin-bottom: 0.3rem;

  padding: 0.5rem 1.5rem;

  border: 1px solid var(--grey-lighten-1);
}
</style>
